import { useMutation } from "@tanstack/react-query";
import { useModalStore } from "../../../lib/store/useModalStore";
import Button from "../../atoms/button";
import { communityArticleCommentDelete, communityArticleDelete } from "../../../@apis/v1/community.service";
import { getQueryClient } from "../../../@apis/queryClient";
import { useNavigate } from "react-router-dom";
import { useDeviceStore } from "../../../lib/store/useDeviceStore";

interface MoreDrawerProps {
  onClose: () => void;
  onClick?: (value: string) => void;
  isMyItem?: boolean;
  type?: "ARTICLE" | "COMMENT";
  articleId: string | number;
  commentId: string | number;
  storeCode?: string;
  next: () => void;
}

export default function MoreDrawerLayout({
  isMyItem = false,
  articleId,
  commentId,
  type,
  storeCode,
  onClose,
  onClick,
  next,
}: MoreDrawerProps) {
  const navigate = useNavigate();
  const { openModal } = useModalStore();
  const { deviceType } = useDeviceStore();

  const commentDeleteMutation = useMutation({
    mutationFn: ({ artiId, comId }: { artiId: string | number; comId: string | number; }) => communityArticleCommentDelete(artiId, comId),
    onSuccess: (res) => {
      const { success, error } = res;
      if (success) {
        getQueryClient().invalidateQueries({ queryKey: ["community-article-comment", articleId] });
        getQueryClient().invalidateQueries({ queryKey: ["community-article-detail", articleId]});
        sessionStorage.setItem("community_needs_refresh", "true");
      } else {
        alert(error?.message);
      }
    },
    onSettled: () => {
      document.body.style.overflow = "auto";
    }
  });

  const articleDeleteMutation = useMutation({
    mutationFn: (id: string | number) => communityArticleDelete(id),
    onSuccess: (res) => {
        const { success, error } = res;
      if (success) {
        // 목록은 staleTime/refetchOnMount:false 라 자동 갱신되지 않으므로
        // 작성/수정과 동일하게 플래그를 남겨 목록 진입 시 제자리 갱신되도록 한다.
        sessionStorage.setItem("community_needs_refresh", "true");
        // 보던 목록의 필터(store)/정렬(sort)을 유지한 채 돌아간다.
        // storeCode(글의 골프장)가 아니라 목록 진입 시 저장한 목록 상태를 사용해야
        // 필터 없던 목록에서 들어와 삭제했을 때 store 가 잘못 붙지 않는다.
        const params = new URLSearchParams();
        if (sessionStorage.getItem("community_came_from_detail") === "true") {
          const savedStore = sessionStorage.getItem("community_store");
          const savedSort = sessionStorage.getItem("community_sort");
          if (savedStore) params.set("store", savedStore);
          if (savedSort) params.set("sort", savedSort);
        }
        const query = params.toString();
        navigate(query ? `/community?${query}` : "/community");
        onClose();
      } else {
        alert(error?.message);
      }
    },
    onSettled: () => {
      document.body.style.overflow = "auto";
    }
  })


  return (
    <section className="space-y-[10px]">
      {isMyItem ? (
        <>
          {type !== "COMMENT" && (
            <Button className="w-full border border-[#e6e6e6] h-[50px]" label="" onClick={() => {
              if (type === "ARTICLE") {
                if (deviceType === "android") {
                  window.open(`/community/edit/${articleId}?store=${storeCode}`, "_blank")
                } else {
                  navigate(`/community/edit/${articleId}?store=${storeCode}`)
                }
              } else if (type === "COMMENT") {
                onClick?.("COMMENT_EDIT");
                onClose();
              }
            }}>          
              <div className="flex-row gap-[14px]">
                <img className="w-[16px] h-[16px]" src="/icons/ic-edit.webp" />
                <span>수정하기</span>
              </div>
            </Button>
          )}
          <Button
            className="w-full border border-[#e6e6e6] h-[50px]"
            label=""
            onClick={() =>
              openModal("CONFIRM_DIALOG", {
                title: "게시물 삭제",
                content: "게시물을 삭제하시겠습니까?",
                onClick: () => {
                  if (type === "ARTICLE")
                    articleDeleteMutation.mutate(articleId);
                  else if (type === "COMMENT")
                    commentDeleteMutation.mutate({
                      artiId: articleId,
                      comId: commentId,
                    });
                  onClose();
                },
              })
            }
          >
            <div className="flex-row gap-[14px]">
              <img className="w-[16px] h-[16px]" src="/icons/ic-delete.webp" />
              <span>삭제하기</span>
            </div>
          </Button>
        </>
      ) : (
        <Button
          onClick={() => next()}
          className="w-full border border-[#e6e6e6] h-[50px]"
          label=""
        >
          <div className="flex-row gap-[14px]">
            <img
              className="w-[16px] h-[16px]"
              src="/icons/ic-declaration.webp"
            />
            <span>신고하기</span>
          </div>
        </Button>
      )}
    </section>
  );
}
